export function containsUrlParam({
  param,
  location,
}: {
  param: string;
  location: Location;
}) {
  const params = new URLSearchParams(location.search);
  return params.has(param);
}
